import { ReactElement } from 'react'

import { Tooltip } from '@verbit-ai/verbit-ui-library'

import { useQuickActionMenu } from './QuickActionContext'
import * as S from './styles'

type QuickActionButtonProps = {
    label: string
    tooltip: string
    icon: ReactElement
    isDisabled?: boolean
    onClick: () => void
}

export const QuickActionButton = (props: QuickActionButtonProps) => {
    const { label, tooltip, icon, isDisabled, onClick } = props
    const { closeMenu } = useQuickActionMenu()

    const handleClick = () => {
        onClick()
        closeMenu()
    }

    return (
        <Tooltip label={tooltip} hasArrow={false} placement="top">
            <S.BasicButton
                variant="ghostLight"
                size="md"
                aria-label={tooltip}
                isDisabled={isDisabled}
                leftIcon={icon}
                onClick={handleClick}>
                {label}
            </S.BasicButton>
        </Tooltip>
    )
}
